export default __webpack_public_path__ + "static/media/my-hero.12a1f45e.webp";